/**
 * Component Entry
 *
 */

import Skeleton from './Skeleton'
export default Skeleton
export * from './Skeleton'
